import { createMutation } from "@/api/utils";
import { Deal } from "./Deal.types";
import pick from "lodash/pick";

type Payload = Pick<
    Deal,
    | "icmCompanyId"
    | "name"
    | "fundraisingAmountMin"
    | "fundraisingAmountMax"
    | "dataroomLink"
>;

export const createDeal = createMutation<Deal, Payload>(
    async ({ api, payload }) => {
        const { uuid } = await api.get(
            "/backend/companies/" + payload.icmCompanyId,
        );
        const { publicToken: teaserProfileToken } = await api.get(
            `/backend/v1/companies/${payload.icmCompanyId}/teaser_profile`,
        );
        return await api.post("/deal-flow/v1/deals", {
            name: payload.name,
            fundraisingAmountMin: payload.fundraisingAmountMin,
            fundraisingAmountMax: payload.fundraisingAmountMax,
            companyId: uuid,
            dataroomLink: payload.dataroomLink,
            teaserProfileToken,
        });
    },
    {
        invalidates: ["/deals"],
        errorToast: {
            message: "Unable to create your deal.",
            options: {
                description: "There was a network error. Please try again.",
            },
        },
    },
);

type PatchPayload = Payload & Pick<Deal, "id" | "status">;
export const updateDeal = createMutation<Deal, PatchPayload>(
    ({ api, payload }) => {
        return api.patch(
            `/deal-flow/v1/deals/${payload.id}`,
            pick(
                payload,
                "status",
                "fundraisingAmountMin",
                "fundraisingAmountMax",
                "name",
                "dataroomLink",
            ),
        );
    },
    {
        invalidates: ["/deals"],
        errorToast: {
            message: "Unable to update this deal.",
            options: {
                description: "There was a network error. Please try again.",
            },
        },
    },
);
